var map = {
	"./AutoField.vue": "v31E",
	"./BooleanField.vue": "tP6R",
	"./CharField.vue": "cpek",
	"./FloatField.vue": "yxKp",
	"./ForeignKey.vue": "PTIS",
	"./FxChoices.vue": "f75F",
	"./IntegerField.vue": "aUd2",
	"./TextField.vue": "P9Qc",
	"./UnknowenField.vue": "w6Vp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WvCJ";


//////////////////
// WEBPACK FOOTER
// ./src/components/DBForm/DBFormContentField nonrecursive \.vue$/
// module id = WvCJ
// module chunks = 1